import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GET_ORG_PROJECT_LIST_PATH } from 'ze-api-contract/organization-v2/get-project-list';
const _orgProjectListKeys = createQueryKeys('organization', {
    projectList: (param)=>{
        let { organization, queryParams } = param;
        return {
            queryKey: [
                GET_ORG_PROJECT_LIST_PATH,
                organization,
                queryParams
            ]
        };
    }
});
export const orgProjectListKeys = _orgProjectListKeys;
